<template>
  <div>
    <vs-row class="mb-3">
      <vs-col vs-w="10" vs-type="flex">
        <Filters />
      </vs-col>
      <vs-col vs-w="2" class="mb-1" vs-type="flex" vs-justify="flex-end">
       <AddNew />
      </vs-col>
    </vs-row>

    <div id="story-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">

        <div class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">

            <div class="flex d-theme-dark-bg items-center border border-b-2 border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light">
                <!-- SEARCH BAR -->
                <vs-input icon-no-border size="large" icon-pack="feather" icon="icon-search" placeholder="Search..." v-model="searchQuery" class="vs-input-no-border w-full" />
            </div>

            <!-- STORY LIST -->

            <component  :is="scrollbarTag" class="story-content-scroll-area" :settings="settings" ref="storyListPS" :key="$vs.rtl">
                <transition-group v-if="isSomeStoryToShow" class="story-list" name="list-enter-up" tag="ul" appear>
                    <li
                      class="cursor-pointer story_story-item"
                      v-for="(story, index) in storyList"
                      :key="String(currentFilter) + String(story.id)"
                      :style="[{transitionDelay: (index * 0.1) + 's'}]"
                    >
                        <Story
                          :storyId="story.id"
                          :key="String(story.createdAt) + String(story.updatedAt)"
                          @showDisplayPrompt="showDisplayPrompt($event)"
                        />
                    </li>
                </transition-group>
                 <div v-else class="m-4">
                  <div v-if="filteredTag">
                    You haven't added any <b>{{filteredTag.icon}} {{filteredTag.text}}</b> yet.
                  </div>
                  <div v-else>
                    You haven't added any yet..
                  </div>
                </div>
            </component>
            <!-- /STORY LIST -->
        </div>

        <!-- EDIT STORY DIALOG -->
        <Edit
          v-if="displayPrompt"
          :displayPrompt="displayPrompt"
          :storyId="storyIdToEdit"
          @hideDisplayPrompt="hidePrompt"
        />
    </div>
  </div>
</template>
<script>
import AddNew from './AddNew.vue'
import Story from './Story.vue'
import Filters from './Filters.vue'
import Edit from './Edit.vue'
import ComingSoon from '../ComingSoon/Notes.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    AddNew,
    Edit,
    Story,
    Filters,
    ComingSoon,
    VuePerfectScrollbar
  },
  data () {
    return {
      currentFilter        : '',
      clickNotClose        : true,
      displayPrompt        : false,
      storyIdToEdit        : 0,
      isSidebarActive      : true,
      settings : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      }
    }
  },
  watch: {
    storyFilter () {
      const scroll_el = this.$refs.storyListPS.$el || this.$refs.storyListPS
      scroll_el.scrollTop = 0

      this.toggleStorySidebar()
      this.fetchStories()
    },
    windowWidth () {
      this.setSidebarWidth()
    }
  },
  computed: {
    anyStory ()   { return this.$store.getters.stories.length > 0 },
    story ()        { return this.$store.state.story.storyArray },
    storyFilter ()  { return this.$route.params.filter },
    storyList ()    { return this.$store.getters.queriedStories },
    isSomeStoryToShow () { return this.storyList.length > 0 },
    searchQuery: {
      get ()        { return this.$store.state.story.storySearchQuery },
      set (val)     { this.$store.dispatch('SET_STORY_SEARCH_QUERY', val) },
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    windowWidth ()  { return this.$store.state.windowWidth },
    filteredTag () {
      const tags = this.$store.state.story.storyTags
      return tags.find((tag) => tag.value === this.storyFilter) || {}
    }
  },
  async created () {
    this.setSidebarWidth()

    await this.fetchTags()
    await this.fetchStories()
  },
  beforeUpdate () {
    this.currentFilter = this.$route.params.filter
  },
  mounted () {
    this.resetSearchQuery()
  },
  methods: {
    async fetchStories () {
      const filter = this.$route.params.filter
      this.$store.commit('UPDATE_STORY_FILTER', filter)
    },
    async fetchTags () {
      await this.$store.dispatch('FETCH_TAGS')
    },
    async resetSearchQuery () {
      await this.$store.dispatch('SET_STORY_SEARCH_QUERY', '')
    },
    showDisplayPrompt (itemId) {
      this.storyIdToEdit = itemId
      this.displayPrompt = true
    },
    hidePrompt () {
      this.displayPrompt = false
    },
    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isSidebarActive = this.clickNotClose = false
      } else {
        this.isSidebarActive = this.clickNotClose = true
      }
    },
    toggleStorySidebar (value = false) {
      if (!value && this.clickNotClose) return
      this.isSidebarActive = value
    },
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/self-improvee/story.scss";

p.emphasize {
  font-size: 130%;
}
</style>
